
import store from '../../config/store'

export default {
  components: {
    'loader-spinner': () => import(/* webpackChunkName: "components" */ '@/common/components/LoaderSpinner.vue')
  },

  data: () => ({
    store
  }),

  computed: {
    title () {
      return store.modal.dataModel.title
    },

    content () {
      return store.modal.dataModel.content
    }
  },

  watch: {
    'store.loading': function () {
      if (!store.loading) {
        store.modal.active = false
      }
    }
  },

  mounted () {
    document.getElementsByClassName('app__container')[0].classList.add('blur')
  },

  destroyed () {
    document.getElementsByClassName('app__container')[0].classList.remove('blur')
  }
}
